import image1 from '../../assets/noprofile.png'




export const Tdata = [
    {
        id : 1,
        image : image1,
        title : " Mohith ",
        description : " a really good job, done by mr.sai pranav i really appriciate his ideas over the project",
                                     
    },
    {
        id : 2,
        image : image1,
        title : "Sudarshan",
        description : "Very nice projects have done by sai pranav . i really appriciate it",
                                     
    },
    {
        id : 3,
        image : image1,
        title : "Sai",
        description : "i gave a web project to be done . it cameout to be very good .",
                                     
    },
    {
        id : 4,
        image : image1,
        title : "Abhi",
        description : " Really good project done by pranav . excellent work.",
                                     
    },

]